import {gql} from '@apollo/client';
import {pwaClient} from './graphql_clients';
import {CreateLeadMutation, CustomerDataInputType, LeadDataInputType} from '../gql/pwa/graphql';
import {pwaRequestHeaders} from '../support/network.ts';

const CREATE_LEAD = gql`
    mutation createLead(
        $customerData: [CustomerDataInputType]
        $leadData: [LeadDataInputType]
        $state: String!
        $leadType: String!
        $leadProviderId: Int
        $customerId: Int
    ) {
        createLead(
            lead: {
                customerData: $customerData
                leadData: $leadData
                state: $state
                lead_type: $leadType
                lead_provider_id: $leadProviderId
                customer_id: $customerId
            }
        ) {
            id
        }
    }
`;

export class Leads {
    static async createLead(
        customerData: CustomerDataInputType[],
        leadData: LeadDataInputType[],
        leadType: string,
        leadProviderId: number,
        customerId: number | null,
    ) {
        return await pwaClient.mutate<CreateLeadMutation>({
            mutation: CREATE_LEAD,
            variables: {
                customerData: customerData,
                leadData: leadData,
                leadType: leadType,
                leadProviderId: leadProviderId,
                state: 'open',
                customerId: customerId,
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });
    }
}
